import React from 'react';
import { Form, Select, Tag } from '@douyinfe/semi-ui';

// 字段类型映射
const fieldTypeMap = {
    string: '文本',
    string2: '多行文本',
    number: '数字',
    select: '单选下拉',
    select2: '单选',
    select3: '单选输入',
    mselect: '多选',
    img: '图片',
    imgs: '多张图片',
    date: '日期',
    time: '时间',
    datetime: '日期时间',
    datetime2: '预约日期时间',
    phone: '手机号',
    range: '区间',
    addr: '地址',
    sign: '签名',
};

const FieldRuleForm = ({ fieldPrefix = '', typeValue }) => {
    // 拼接字段名
    const f = (name) => fieldPrefix ? `${fieldPrefix}.${name}` : name;
    return (
        <>
            <Form.Input
                field={f('n')}
                label="字段名称"
                rules={[{ required: true, message: '请输入字段名称' }]}
            />
            <Form.Switch
                field={f('r')}
                label="必填"
            />
            <Form.Select
                field={f('t')}
                label="类型"
                style={{ width: '100%' }}
                rules={[{ required: true, message: '请选择字段类型' }]}
            >
                {Object.entries(fieldTypeMap).map(([value, label]) => (
                    <Select.Option key={value} value={value}>{label}（{value}）</Select.Option>
                ))}
            </Form.Select>
            <Form.Input
                field={f('d')}
                label="默认值"
            />
            <Form.Input
                field={f('p')}
                label="校验规则"
            />
            <Form.Input
                field={f('l')}
                label="选项"
                placeholder="如有多个用逗号分隔"
                rules={typeValue === 'select' || typeValue === 'mselect' ? [{ required: true, message: '选项为必填' }] : []}
            />
            <Form.Switch
                field={f('u')}
                label="唯一"
            />
        </>
    );
};

export default FieldRuleForm; 